










import { Component, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import AddUpdateSpace from './components/add-update-space.vue';
import { PARKING_SPACE_LIST } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddUpdateSpace }
})
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  // 面板屑
  private navs: any = [
    {
      label: '车位资源管理',
      location: {
        name: routeNames.PARKING_SPACE_LIST
      }
    },
    { label: '车位修改' }
  ];
  isEdit: boolean = true;
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  goBack() {
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: PARKING_SPACE_LIST
    });
  }
}
